import AxiosCdp from '@/services/api/cdp/axios_cdp'

export default {
  sendCommand: (params) => {
    return AxiosCdp.post('cdp/console', params)
  },
}